import { render } from "./AccountsAccount.vue?vue&type=template&id=0fb4b1d9"
import script from "./AccountsAccount.vue?vue&type=script&lang=js"
export * from "./AccountsAccount.vue?vue&type=script&lang=js"
script.render = render

export default script